function Tooltip(tooltipContainer, timeoutLength) {
    const trigger = tooltipContainer.classList.contains('tooltip-trigger') ? tooltipContainer : tooltipContainer.querySelector('.tooltip-trigger');
    const tooltip = tooltipContainer.querySelector('.tooltip');
    const TIMEOUT_LENGTH = timeoutLength ? timeoutLength : 500;
    let timeout = null;

    const showTooltip = () => {
        // need to identify where to display the container so that it does not fall off
        // view from the viewport
        tooltip.style.display = 'block';
        var triggerWidth = trigger.offsetWidth;
        var tooltipWidth = tooltip.offsetWidth;
        var rect = trigger.getBoundingClientRect();

        // furthest right position
        var rightMostPos = rect.left + (triggerWidth / 2) + (tooltipWidth / 2);
        var totalWidth = document.documentElement.clientWidth || document.body.clientWidth;

        // get position of parent element
        var containerLeft = rect.left;
        var leftmostPos = containerLeft - (tooltipWidth / 2);

        tooltip.removeAttribute('aria-hidden');
        tooltip.style.left = `${triggerWidth / 2}px`;
        tooltipContainer.classList.add('displayed');

        // if the right most position is further out than the viewport
        // then move it so it is fully in the viewport
        if (rightMostPos > totalWidth) {
            // identify where left should be
            var newPos = rightMostPos - totalWidth - (triggerWidth / 2);
            tooltip.style.left = `-${newPos + 20}px`;
        }

        // if the left most position is further out than the viewport
        // then move it so it is fully in the viewport
        if (leftmostPos < 0) {
            var newPos = (tooltipWidth / 2) - containerLeft;
            tooltip.style.left = `${newPos + 5}px`;
        }

        // if a hide timeout exists for this tooltip, clear it
        if (timeout) {
            window.clearTimeout(timeout);
        }
    }

    const hideTooltip = () => {
        tooltipContainer.classList.remove('displayed');
        tooltip.style.display = 'none';
        tooltip.setAttribute('aria-hidden', 'true');
    }

    const timeoutTooltip = () => {
        // hide the tooltip after a set amount of time
        timeout = window.setTimeout(() => {
            hideTooltip(tooltip);
        }, TIMEOUT_LENGTH);
    }

    // show tooltip on hover and focus
    tooltipContainer.addEventListener('mouseenter', () => {
        showTooltip();
    });
    trigger.addEventListener('focus', () => {
        showTooltip();
    });

    // hide tooltip on mouse out and blur
    // use timeout on mouse leave
    tooltipContainer.addEventListener('mouseleave', () => {
        timeoutTooltip();
    });
    trigger.addEventListener('blur', () => {
        hideTooltip();
    });

    // hide the tooltip on escape key press
    trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            hideTooltip();
        } else if (event.key === 'Enter') {
            showTooltip();
        }
    });

    // keydown events don't fire on non-editable content
    // this will remove ALL tooltips, but seeing as there's a timeout then it's unlikely
    // many will be open at the same time
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            hideTooltip();
        }
    });

    // create a close button for pointer dismissal
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = 'X';
    closeBtn.tabIndex = -1;
    closeBtn.type = "button";
    closeBtn.setAttribute('aria-hidden', 'true');
    closeBtn.classList.add('tooltip-close');
    tooltip.appendChild(closeBtn);
    closeBtn.addEventListener('click', () => {
        hideTooltip();
    });

    // hide the tooltip in here so they show up without JS on
    // debateably useful
    tooltip.style.display = 'none';

}

export default Tooltip